import React from 'react'
import StatisticsDeleteBasketPage from './StatisticsDeleteBasketPage'
import '../styles/index.scss'

function StatisticsDeleteBasketContainer() {
    return (
        <div className='StatisticsDeleteBasketContainer'>
            <StatisticsDeleteBasketPage />
        </div>
    )
}

export default StatisticsDeleteBasketContainer